<template>
  <div v-if="page" class="min-h-screen bg-soft-white">
    <article class="container mx-auto px-6 py-12 max-w-3xl">
      <nav class="text-sm text-dark-gray/60 mb-4" aria-label="Breadcrumb">
        <RouterLink to="/" class="hover:text-light-purple">Home</RouterLink>
        <span class="mx-1">/</span>
        <RouterLink to="/resources" class="hover:text-light-purple">Resources</RouterLink>
        <span class="mx-1">/</span>
        <span class="text-dark-gray">{{ page.h1 }}</span>
      </nav>
      <h1 class="text-4xl font-poppins font-bold text-dark-gray mt-4 mb-4">{{ page.h1 }}</h1>
      <p class="text-lg text-dark-gray/75 mb-8 leading-relaxed">{{ page.intro }}</p>
      <ul class="card-neumorphic !p-6 mb-8 space-y-2">
        <li v-for="b in page.bullets" :key="b" class="flex gap-2 text-dark-gray/80">
          <span class="text-light-purple">•</span> {{ b }}
        </li>
      </ul>
      <p v-for="(para, i) in page.paragraphs" :key="i" class="text-dark-gray/75 leading-relaxed mb-4">
        {{ para }}
      </p>
      <section v-if="page.faqs?.length" class="card-neumorphic !p-6 mb-8">
        <h2 class="text-xl font-semibold mb-4">FAQs</h2>
        <div v-for="f in page.faqs" :key="f.q" class="mb-3">
          <h3 class="font-semibold">{{ f.q }}</h3>
          <p class="text-sm text-dark-gray/70">{{ f.a }}</p>
        </div>
      </section>
      <div class="mt-8 flex flex-wrap gap-3">
        <RouterLink
          v-for="href in page.related"
          :key="href"
          :to="href"
          class="text-sm px-3 py-2 rounded-xl bg-lavender-tint/40 text-light-purple"
        >{{ href }}</RouterLink>
      </div>
    </article>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getResourcePage } from '../config/resources'
import {
  breadcrumbSchema,
  faqSchema,
  graphSchema,
  organizationSchema,
  useSeo,
} from '../composables/useSeo'

export default {
  name: 'ResourcePage',
  setup() {
    const route = useRoute()
    const page = computed(() => getResourcePage(route.params.slug))
    useSeo(
      computed(() => {
        const p = page.value
        if (!p) return { title: 'Not found', robots: 'noindex', path: '/resources' }
        const path = `/resources/${p.slug}`
        return {
          title: p.title,
          description: p.description,
          path,
          keywords: [p.h1, 'Homvisit resource'],
          schema: graphSchema([
            organizationSchema(),
            breadcrumbSchema([
              { name: 'Home', path: '/' },
              { name: 'Resources', path: '/resources' },
              { name: p.h1, path },
            ]),
            faqSchema(p.faqs),
          ]),
        }
      })
    )
    return { page }
  },
}
</script>
